import { createV3Queries } from "@query/utils/createV3Queries";
import { insuranceImportsApi } from "@api";

import { queriesInsuranceCoverages } from "./queriesInsuranceCoverages";

/**
 * Insurance-import registry — mirrors `InsuranceImportsApi` 1:1
 * (`/v3/compliance/insurance-imports`; no list endpoint exists on v3, and
 * SDK 3.13.0 dropped the delete endpoint that used to answer 501).
 * A submitted import produces/updates a coverage, so import writes refresh
 * the coverage reads.
 */
export const queriesInsuranceImports = createV3Queries(
  "insuranceImportsApi",
  insuranceImportsApi,
  {
    createInsuranceImport: () => ({
      dependencies: () => [
        queriesInsuranceCoverages.listInsuranceCoverages.queryKeyBase
      ]
    }),
    updateInsuranceImport: () => ({
      dependencies: () => [
        queriesInsuranceCoverages.listInsuranceCoverages.queryKeyBase
      ]
    }),
    submitInsuranceImport: () => ({
      dependencies: () => [
        queriesInsuranceCoverages.listInsuranceCoverages.queryKeyBase
      ]
    })
  }
);
